module.exports = __webpack_public_path__ + "e18bbf611f2a2e43afc071aa2f4e1512.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./styles/fonts/glyphicons-halflings-regular.ttf
 ** module id = 195
 ** module chunks = 0
 **/